import React from 'react';
import { ShowIf } from 'components/utils';
import { msg } from "constants/message";
import { PhoneNumber, CMNDNumber } from 'base/lib/validate';
import { validatable } from 'components/utils';

class Input extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.value,
      isValid: true
    }
  }

  onChange(e) {
    if (this.props.type == 'sdt') {
      e.target.value = PhoneNumber(e.target.value);
    } else if (this.props.type == 'cmnd') {
      e.target.value = CMNDNumber(e.target.value);
    }
    this.setState({
      value: e.target.value,
      isValid: true
    });
    if (this.props.triggeOnBlur != true) {
      this.props.onChange(e);
    }
  }

  handleBlur(e) {
    e.target.value = e.target.value.trim();
    if (this.props.triggeOnBlur == true) {
      if (this.props.type == 'sdt') {
        e.target.value = PhoneNumber(e.target.value);
      } else if (this.props.type == 'cmnd') {
        e.target.value = CMNDNumber(e.target.value);
      }
      this.setState({
        value: e.target.value
      });
      this.props.onChange(e);
    }
    this.props.onBlur();
  }

  componentWillReceiveProps(nextProps) {

    this.setState({
      value: nextProps.value
    });
    if (nextProps.require && typeof nextProps.value == 'string' && nextProps.value.trim()) {
      this.setState({
        isValid: true
      });
    }

  }

  classNames() {
    if (this.state.isValid) {
      return 'pt-input';
    } else {
      return 'pt-input pt-intent-danger';
    }
  }

  validate() {
    if (((typeof this.state.value == 'string' && this.state.value.trim() == '') || (this.props.type == 'sdt' && this.state.value == 0)) && this.props.require) {
      this.setState({
        isValid: false
      });
      this.input.focus();
      return false;
    } else {
      this.setState({
        isValid: true
      });
      return true;
    }
  }

  handleFocus(e) {
    e.target.select();
  }

  render() {
    return (
      <div className={this.props.className + ' mb18'}>
        <ShowIf condition={this.props.label != ''}>
          <label className="ip-label">
            {this.props.label}
            <ShowIf condition={this.props.require}>
              <span className="text-required">&nbsp;*</span>
            </ShowIf>
          </label>
        </ShowIf>
        <input disabled={this.props.disabled} onBlur={this.handleBlur.bind(this)} onFocus={this.handleFocus.bind(this)} style={{ textAlign: this.props.align }} type="text" className={this.classNames()} ref={(input) => { this.input = input }} maxLength={this.props.maxLength > 0 ? this.props.maxLength : (this.props.type == 'sdt' ? 15 : 255)} value={this.state.value} onChange={this.onChange.bind(this)} placeholder={this.props.placeholder} name={this.props.name} onKeyDown={this.props.onKeyDown} />
        <ShowIf condition={!this.state.isValid && this.state.value.trim() == ''}>
          <div className="pt-form-helper-text">{msg.messageDefault}</div>
        </ShowIf>
        <ShowIf condition={!this.state.isValid && this.state.value.trim() != '' && this.state.value == 0}>
          <div className="pt-form-helper-text">{msg.dataInvalid}</div>
        </ShowIf>
        <ShowIf condition={this.props.trungMa === true}>
          <div className="pt-form-helper-text">Mã doanh nghiệp đã tồn tại trong hệ thống</div>
        </ShowIf>
      </div>
    );
  }
}

Input.defaultProps = {
  type: '',
  className: 'input-group',
  label: '',
  align: 'left',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  onBlur: function () {},
  onKeyDown: function () {},
  placeholder: null,
  require: false,
  maxLength: 0,
  name: '',
  triggeOnBlur: false,
  disabled: false,
  trungMa: false
}

export default validatable(Input);



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/Input.jsx